import { render, staticRenderFns } from "./classInformation.vue?vue&type=template&id=60f53534&scoped=true&"
import script from "./classInformation.vue?vue&type=script&lang=js&"
export * from "./classInformation.vue?vue&type=script&lang=js&"
import style0 from "./classInformation.vue?vue&type=style&index=0&id=60f53534&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f53534",
  null
  
)

export default component.exports